import React, { memo, useCallback, useState, useEffect } from 'react';

import { Formik, Form } from 'formik';
import type { FormikProps } from 'formik';
import { FilterPanel } from 'v2/components/Shared/FilterPanel';
import { useQuery } from 'v2/hooks/useQuery';
import type { IFilter, IStatusFilter } from 'v2/interfaces/affiliate';
import affiliateService, { InitialFilter } from 'v2/services/affiliate';

import Basic from './Basic';
import FilterAffiliateSchema from './validations';

const Filter = () => {
  const [filter, setFilter] = useState<IFilter>(InitialFilter);
  const params = useQuery();

  const onSubmit = useCallback((values: IFilter, { setSubmitting }: FormikProps<IFilter>) => {
    affiliateService.setFilter(values);
    setSubmitting(false);
  }, []);

  useEffect(() => {
    const product = params.get('p');
    const status = params.get('status');
    const f = filter;

    if (product) {
      f.product_id = [Number(product)];
    }

    if (status) {
      const s: IStatusFilter = status as IStatusFilter;
      f.status = s;
    }

    setFilter(f);
  }, [filter, params]);

  return (
    <Formik initialValues={filter} validationSchema={FilterAffiliateSchema} onSubmit={onSubmit}>
      {() => (
        <Form>
          <FilterPanel id='affiliates-filter-panel'>
            <Basic />
          </FilterPanel>
        </Form>
      )}
    </Formik>
  );
};

export default memo(Filter);
